interface IProps {
    color?: string;
}

export const CrownCustom = (props: IProps) => {
    const { color } = props;

    return (
        <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.5651 12.8279C2.21246 10.5357 1.85982 8.24358 1.50717 5.95137C1.42897 5.44325 2.00712 5.09669 2.41837 5.40516C3.51705 6.22917 4.61568 7.05313 5.71436 7.87714C6.0761 8.14844 6.59147 8.06015 6.84226 7.68392L9.58623 3.56792C9.87621 3.13296 10.5153 3.13296 10.8053 3.56792L13.5492 7.68392C13.8 8.06015 14.3154 8.14839 14.6771 7.87714C15.7758 7.05313 16.8744 6.22917 17.9731 5.40516C18.3844 5.09669 18.9625 5.44325 18.8844 5.95137C18.5317 8.24358 18.1791 10.5357 17.8265 12.8279L2.5651 12.8279Z" fill={color || "#FFB743"} />
            <path d="M17.0308 16.6434H3.36085C2.92142 16.6434 2.56519 16.2871 2.56519 15.8477V14.0999H17.8265V15.8477C17.8265 16.2871 17.4702 16.6434 17.0308 16.6434Z" fill={color || "#FFB743"} />
            <circle cx="10.2133" cy="1.77583" r="0.900827" fill={color || "#FFB743"} />
            <circle cx="19.2758" cy="4.27583" r="0.900827" fill={color || "#FFB743"} />
            <circle cx="1.15083" cy="4.27583" r="0.900827" fill={color || "#FFB743"} />
        </svg>

    );
};
